import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  openFilterDrawer: false,
};

const slice = createSlice({
  name: 'utils',
  initialState,
  reducers: {
    handleOpenFilterDialog: (state, action) => {
      state.openFilterDrawer = action.payload;
    },
  },
});

export const { handleOpenFilterDialog } = slice.actions;
export default slice.reducer;
